import React from "react";
import { Route, Routes } from "react-router-dom";
import JobOffersPage from "../../pages/module-pages/job-offers/JobOffersPage";
import NewJobOfferPage from "../../pages/module-pages/job-offers/NewJobOfferPage";
import UpdateJobOfferPage from "../../pages/module-pages/job-offers/UpdateJobOfferPage";

export default function JobOfferNav() {
  return (
    <Routes>
      <Route path="/" element={<JobOffersPage />} />
      <Route path="/new" element={<NewJobOfferPage />} />
      <Route path="/update" element={<UpdateJobOfferPage />} />
    </Routes>
  );
}
